import { Link } from 'react-router-dom';

interface DropdownItemProps {
  onItemClick: () => void;
  tag?: string;
  to?: string;
  className?: string;
  children: React.ReactNode;
}

export function DropdownItem({ onItemClick, tag, to, className = '', children }: DropdownItemProps) {
  if (tag === 'a' && to) {
    return (
      <Link to={to} onClick={onItemClick} className={className}>
        {children}
      </Link>
    );
  }

  return (
    <button onClick={onItemClick} className={className}>
      {children}
    </button>
  );
}
